var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenanceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 60,
    viewBox: "0 0 65 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5 0.75H6.5C4.77763 0.755013 3.12724 1.44144 1.90934 2.65934C0.691442 3.87724 0.00501266 5.52763 0 7.25V52.75C0.00501266 54.4724 0.691442 56.1228 1.90934 57.3407C3.12724 58.5586 4.77763 59.245 6.5 59.25H58.5C60.2224 59.245 61.8728 58.5586 63.0907 57.3407C64.3086 56.1228 64.995 54.4724 65 52.75V7.25C64.995 5.52763 64.3086 3.87724 63.0907 2.65934C61.8728 1.44144 60.2224 0.755013 58.5 0.75ZM26 46.25H9.75V39.75H26V46.25ZM26 33.25H9.75V26.75H26V33.25ZM26 20.25H9.75V13.75H26V20.25ZM41.665 39.75L32.5 30.52L37.083 25.937L41.665 30.55L51.965 20.25L56.58 24.865L41.665 39.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceIcon);
export default __webpack_public_path__ + "static/media/maintenanceIcon.c6262a9b.svg";
export { ForwardRef as ReactComponent };